<form *ngIf="formGroup" [formGroup]="formGroup">
  <button *ngIf="isCleanable" type="button" class="button" (click)="reset()">{{ "components.personal-information.reset" | translate }}</button>
  <div class="row row-block">
    <mat-form-field class="col-12 col-sm-6" appearance="fill" [ngClass]="{'mat-form-field-readonly': formGroup.get('lastName')?.readonly }">
      <mat-label>
        {{ "components.personal-information.last-name" | translate }}
      </mat-label>
      <input type="text" matInput formControlName="lastName" [required]="isMandatory" [readonly]="formGroup.get('lastName')?.readonly" />
      <mat-error
        *ngIf="formGroup.get('lastName')?.hasError('required')"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('lastName')?.errors?.maxlength as maxlengthError"
        translate
      >
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="col-12 col-sm-6" appearance="fill" [ngClass]="{'mat-form-field-readonly': formGroup.get('firstName')?.readonly }">
      <mat-label>
        {{ "components.personal-information.first-name" | translate }}
      </mat-label>
      <input type="text" matInput formControlName="firstName" [required]="isMandatory" [readonly]="formGroup.get('firstName')?.readonly" />
      <mat-error
        *ngIf="formGroup.get('firstName')?.hasError('required')"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('firstName')?.errors?.maxlength as maxlengthError"
        translate
      >
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="addressFormGroup">
    <form-address-completion
      [formGroup]="addressFormGroup"
      [isSwissOnly]="isSwissOnly"
      [isMandatory]="isMandatory"
    ></form-address-completion>
    <div class="row">
      <mat-form-field class="col-12 col-sm-3" appearance="fill">
        <mat-label>
          {{ "components.personal-information.po-box" | translate }}
        </mat-label>
        <input type="text" matInput formControlName="poBox" />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <mat-form-field class="col-12 col-sm-6" appearance="fill">
      <mat-label>
        {{ "components.personal-information.phone" | translate }}
      </mat-label>
      <input
        type="text"
        matInput
        formControlName="phone"
        [placeholder]="'forms.phone-format-placeholder' | translate"
        [required]="isMandatory"
        prefix="+"
        mask="00 00 000 00 009999"
        [showMaskTyped]="false"
        [dropSpecialCharacters]="false"
        [validation]="false"
      />
      <mat-hint>
        {{ "forms.phone-format-hint" | translate }}
      </mat-hint>
      <mat-error
        *ngIf="formGroup.get('phone')?.hasError('required'); else phoneInvalid"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <ng-template #phoneInvalid>
        <mat-error
          *ngIf="formGroup.get('phone')?.hasError('invalidPhoneNumber')"
          translate
        >
          forms.errors.phone-invalid
        </mat-error>
      </ng-template>
    </mat-form-field>
    <mat-form-field class="col-12 col-sm-6" appearance="fill" [ngClass]="{'mat-form-field-readonly': formGroup.get('email')?.readonly }">
      <mat-label>
        {{ "components.personal-information.email" | translate }}
      </mat-label>
      <input type="text" matInput formControlName="email" [required]="isMandatory" [readonly]="formGroup.get('email')?.readonly" />
      <mat-error
        *ngIf="formGroup.get('email')?.hasError('required'); else emailInvalid"
        translate
      >
        forms.errors.field-required
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('email')?.errors?.maxlength as maxlengthError"
        translate
      >
        <span translate [translateParams]="{ maxLength: maxlengthError.requiredLength, currentLength: maxlengthError.actualLength }">
          forms.errors.max-length
        </span>
      </mat-error>
      <ng-template #emailInvalid>
        <mat-error *ngIf="formGroup.get('email')?.hasError('email')" translate>
          forms.errors.email-invalid
        </mat-error>
      </ng-template>
    </mat-form-field>
    <mat-form-field class="col-md-6 col-12" appearance="fill" [ngClass]="{'mat-form-field-readonly': formGroup.get('dateOfBirth')?.readonly }">
      <mat-label>
        {{ "patient-consent.basic-information.date-of-birth" | translate }}
      </mat-label>
      <input
        matInput
        [matDatepicker]="dateOfBirthInput"
        [min]="dateOfBirthMin"
        [max]="dateOfBirthMax()"
        formControlName="dateOfBirth"
        [required]="isMandatory"
        [readonly]="formGroup.get('dateOfBirth')?.readonly"        
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="dateOfBirthInput"
        [disabled]="formGroup.get('dateOfBirth')?.readonly"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateOfBirthInput></mat-datepicker>
      <mat-error
        *ngIf="
          formGroup.get('dateOfBirth')?.hasError('matDatepickerParse');
          else isRequired
        "
        translate
      >
        forms.errors.date-invalid
      </mat-error>
      <ng-template #isRequired>
        <mat-error
          *ngIf="
            formGroup.get('dateOfBirth')?.hasError('required');
            else dateMin
          "
          translate
        >
          forms.errors.field-required
        </mat-error>
      </ng-template>
      <ng-template #dateMin>
        <mat-error
          *ngIf="
            formGroup.get('dateOfBirth')?.hasError('matDatepickerMin');
            else dateMax
          "
          translate
          [translateParams]="{
            min:
              formGroup.get('dateOfBirth')?.errors?.matDatepickerMin?.min | date
          }"
        >
          forms.errors.date-min
        </mat-error>
      </ng-template>
      <ng-template #dateMax>
        <mat-error
          *ngIf="formGroup.get('dateOfBirth')?.hasError('matDatepickerMax')"
          translate
          [translateParams]="{
            max:
              formGroup.get('dateOfBirth')?.errors?.matDatepickerMax?.max | date
          }"
        >
          forms.errors.date-max
        </mat-error>
      </ng-template>
    </mat-form-field> 
  </div>
  <div *ngIf="formGroup.get('avs')" class="row">
    <mat-form-field class="col-md-6 col-12" appearance="fill">
      <mat-label>
        {{ "patient-consent.basic-information.avs-number" | translate }}
      </mat-label>
      <input
        matInput
        formControlName="avs"
        id="AvsNumber"
        required
        prefix="756."
        mask="0000.0000.00"
        [showMaskTyped]="true"
        [dropSpecialCharacters]="false"
      />
      <mat-hint>
        {{ "patient-consent.basic-information.avs-number-help" | translate }}
      </mat-hint>
      <mat-error *ngIf="formGroup.get('avs')?.hasError('required')" translate>
        forms.errors.field-required
      </mat-error>
      <mat-error *ngIf="formGroup.get('avs')?.hasError('pattern')">
        {{
          "patient-consent.basic-information.avs-number-format-invalid"
            | translate
        }}
      </mat-error>
      <mat-error
        *ngIf="formGroup.get('avs')?.hasError('avsControlDigitInvalid')"
      >
        {{ "patient-consent.basic-information.avs-number-invalid" | translate }}
      </mat-error>
    </mat-form-field>
  </div>  
</form>
